import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import { getProductSalesReportTableProps } from './productSalesReportTableProps';

const ReportTable = ({ rows, total }) => {
  const props = useMemo(() => getProductSalesReportTableProps({ rows, total }), [rows, total]);

  return <Reconnect name="ReportTable" props={props} />;
};

export default ReportTable;
